import React from "react";
import { Calendar, ArrowRight } from "lucide-react";
import { news } from "../mock";
import { PageHeader } from "./Contatti";

const NewsPage = () => (
  <>
    <PageHeader title="News & Novità" subtitle="Aggiornamenti, novità di prodotto, promozioni e notizie dal mondo Metal Solutions." />
    <section className="py-20 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {news.map((n) => (
          <article key={n.id} className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all">
            <div className="aspect-[16/10] overflow-hidden">
              <img src={n.image} alt={n.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-3 mb-3 text-xs text-gray-500">
                <span className="bg-[#00A859]/10 text-[#00A859] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider">{n.category}</span>
                <span className="flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {n.date}</span>
              </div>
              <h3 className="text-lg font-bold text-[#0B2545] mb-2 leading-tight group-hover:text-[#00A859] transition-colors">{n.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">{n.excerpt}</p>
              <button className="text-[#00A859] font-bold text-sm uppercase tracking-wide inline-flex items-center gap-1.5 hover:gap-2.5 transition-all">
                Leggi di più <ArrowRight className="w-3.5 h-3.5" />
              </button>
            </div>
          </article>
        ))}
      </div>
    </section>
  </>
);

export default NewsPage;
